<template>
  <div class="container">
    <!-- Menú con botones -->
    <div class="menu">
      <button
        class="menu-btn"
        :class="{ active: selectedComponent === 0 }"
        @click="selectedComponent = 0">REPORTE DE DESPACHOS POR SERIE</button>
      <!-- <button
        class="menu-btn"
        :class="{ active: selectedComponent === 1 }"
        @click="selectedComponent = 1">Reporte Prueba</button> -->
    </div>

    <!-- Mostrar componente basado en el valor de selectedComponent -->
    <div class="component-content">
      <component :is="currentComponent"></component>
    </div>
    <br><br><br><br><br><br><br><br><br><br>
  </div>
</template>

<script>
const BodegaReporteCodigosSeriesVue   = () => import('./BodegaReporteCodigosSeries.vue');
// const BodegaReportePruebaVue          = () => import('./BodegaReportePrueba.vue');
export default {
  components: {
    BodegaReporteCodigosSeriesVue,
    // BodegaReportePruebaVue,
  },
  data() {
    return {
      selectedComponent: 0, // Inicializa con el componente 0
    };
  },
  computed: {
    currentComponent() {
      // const components = [BodegaReporteCodigosSeriesVue, BodegaReportePruebaVue];
      const components = [BodegaReporteCodigosSeriesVue];
      return components[this.selectedComponent];
    },
  },
};
</script>

<style scoped>
/* Contenedor general */
.container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  background-color: #fff;
}

/* Menú de navegación */
.menu {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  padding: 10px 0;
  border-radius: 8px;
}

/* Estilo de los botones del menú */
.menu-btn {
  padding: 10px 20px;
  margin: 0 10px;
  background-color: rgb(83, 116, 179);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

/* Botón activo */
.menu-btn.active {
  background-color: #3F51B5;
  transform: scale(1.1);
}

/* Hover de los botones */
.menu-btn:hover {
  background-color: #3F51B5;
}

/* Estilo de la sección de contenido */
.content {
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

/* Agregar un poco de espacio entre los componentes */
.content > * {
  max-width: 800px;
  width: 100%;
  padding: 20px;
}

/* Componente base */
h2 {
  color: #333;
}

p {
  font-size: 16px;
  color: #666;
}
</style>
